import IconButton from "@mui/material/IconButton";
import { theme as defaultTheme } from "@mindlercare/ui-web";
import { styled } from "styled-components";

export const Container = styled.div`
  position: relative;
  min-width: 200px;
`;

export const MonthPickerDiv = styled.div`
  display: flex;
  flex-wrap: wrap;
`;

export const MonthPickerElement = styled.div`
  display: flex;
  height: 48px;
  flex: 0 0 25%;
  text-align: center;
  background-color: ${defaultTheme.COLORS.WHITE};
  align-items: center;
  justify-content: center;
  cursor: pointer;

  &:hover {
    background-color: ${({ theme }) => defaultTheme.COLORS.GRAY_X_LIGHT};
    transition: ${({ theme }) => defaultTheme.TRANSITION.STANDARD_TRANSITION};
    text-decoration: underline black;
  }
`;

export const MonthPickerElementText = styled.p<{ isCurrentMonth: boolean }>`
  font-family: ${defaultTheme.FONT.FAMILY.BODY};
  color: ${defaultTheme.COLORS.GRAY_BLACK};
  font-weight: ${(props) => (props.isCurrentMonth ? 700 : 400)};
  font-style: normal;
  line-height: 22px;
  font-size: ${defaultTheme.FONT.SIZE.STANDARD};
`;

export const InnerContainer = styled.div`
  background-color: ${defaultTheme.COLORS.WHITE};
  filter: drop-shadow(0px 2px 8px rgba(3, 48, 36, 0.2));
  width: 224px;
  height: 185px;
  position: absolute;
  z-index: 100;
  margin-top: 8px;
  left: 50px;
`;

export const YearPickerDiv = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 224px;
  height: 41px;
  border-bottom: 1px solid ${defaultTheme.COLORS.GRAY_MEDIUM};
`;

export const MonthPickerText = styled.p`
  font-family: ${defaultTheme.FONT.FAMILY.BODY};
  font-size: 1rem;
  line-height: 22px;
  font-style: normal;
  font-weight: 700;
  color: ${defaultTheme.COLORS.GRAY_BLACK};
`;

export const Icon = styled(IconButton)`
  height: 40px;
  width: 40px;
  display: flex;
  justify-content: center;
  color: ${defaultTheme.COLORS.GRAY_BLACK};
  align-items: center;
`;
